// extracted by mini-css-extract-plugin
export default {"wrapper":"SiteHeader_wrapper__jyv6M"};